import {
  GET_MESSAGES_LIST,
  CREATE_MESSAGE,
} from '@redturtle/volto-io-cittadino/actions/messages';

const initialState = {
  loading: false,
  loaded: false,
  result: {},
  error: null,
};

// Get messages list
export const listMessages = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_MESSAGES_LIST}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_MESSAGES_LIST}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_MESSAGES_LIST}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const ioCittadinoMessage = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${CREATE_MESSAGE}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${CREATE_MESSAGE}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${CREATE_MESSAGE}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};
